import * as React from "react";
import StoreContainer from "../stores/StoreContainer";
import CloseChatForm from "./CloseChatForm";
import Header from "./Header";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface Props {
  isPopout: boolean;
  onClose: () => void;
}

class PostChatSurveySubmitted extends React.Component<Props, {}> {
  surveyContent = StoreContainer.EngagementStore.getPostchatSurveyContent();

  render() {
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onCollapse={() => StoreContainer.FrameStore.collapseOrClose()}
        />
        <div className="velaro-confirmation-text">
          {this.surveyContent.ConfirmationText}
          <div className="survey-close-button">
            <CloseChatForm onClose={this.props.onClose} />
          </div>
        </div>
      </MessengerFlexContainer>
    );
  }
}

export default PostChatSurveySubmitted;
